<script lang="ts">
  import { createEventDispatcher } from "svelte";

  const dispatcher = createEventDispatcher();

  function goBackToLogin() {
    dispatcher("modeChanged", "login");
  }
</script>

<h2 class="mb-4 text-18 font-bold text-nxgray-600">Now, you'll need to create a password to log in 🔑</h2>
<p class="w-full text-13 text-nxgray-400">Check the email you entered for further instructions on how to create a new password!</p>
<button
  class="clickable mt-5 flex w-full justify-center rounded bg-warning-600 py-3 text-15 font-bold text-white outline-none hover:bg-warning-500 focus:bg-warning-500 focus:outline-none"
  on:click={goBackToLogin}>Back to login</button>
